import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
import Sidebar from "components/Sidebar/Sidebar";
import TopBar from "components/Navbars/TopBar";

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    });
  };

  const cls = [
    "lms-app",
    collapsed && "sidebar-collapsed",
    sidebarOpen && "sidebar-open",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls}>
      <Sidebar
        routes={routes}
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
      />
      <div className="lms-main">
        <TopBar onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        <Switch>
          {getRoutes(routes)}
          <Redirect from="/admin" to="/admin/dashboard" />
        </Switch>
      </div>
      {sidebarOpen && (
        <div
          className="lms-sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
